import { render, staticRenderFns } from "./budgetPreparationDetail.vue?vue&type=template&id=3ad8e22c&scoped=true&"
import script from "./budgetPreparationDetail.vue?vue&type=script&lang=js&"
export * from "./budgetPreparationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad8e22c",
  null
  
)

export default component.exports